import { createSlice } from "@reduxjs/toolkit";

import {
    getAllSourcesRedux,
    getJsSourcesRedux,
    getSourceForAddingTrackers,
} from "./sources.asyncActions";

const initialState = {
    getAllSources: {
        message: "",
        status: "idle",
        sources: [],
        sourceJs: [],
        statusSourceJs: "idle",
        statusforAddingTrackersSource: "idle",
        sourcesForAddingTracker: [],
    },
};

export const sourcesSlice = createSlice({
    name: "allSourcesState",
    initialState,
    reducers: {
        updateSourceInList: (state, action) => {
            const { id, changes } = action.payload;
            const patch = (arr) => {
                if (!Array.isArray(arr)) return;
                const idx = arr.findIndex((s) => s?.id === id);
                if (idx !== -1) {
                    arr[idx] = { ...arr[idx], ...changes };
                }
            };
            patch(state.getAllSources.sources);
            patch(state.getAllSources.sourceJs);
            patch(state.getAllSources.sourcesForAddingTracker);
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllSourcesRedux.pending, (state) => {
                state.getAllSources.status = "loading";
            })
            .addCase(getAllSourcesRedux.fulfilled, (state, action) => {
                state.getAllSources.status = "success";
                state.getAllSources.sources =
                    action.payload.data && action.payload.data;
                state.getAllSources.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getAllSourcesRedux.rejected, (state, action) => {
                state.getAllSources.status = "failed";
                state.getAllSources.message =
                    action.payload.message && action.payload.message;
            })
            .addCase(getSourceForAddingTrackers.pending, (state) => {
                state.getAllSources.statusforAddingTrackersSource = "loading";
            })
            .addCase(getSourceForAddingTrackers.fulfilled, (state, action) => {
                state.getAllSources.statusforAddingTrackersSource = "success";
                state.getAllSources.sourcesForAddingTracker =
                    action.payload.data && action.payload.data;
            })
            .addCase(getSourceForAddingTrackers.rejected, (state, action) => {
                state.getAllSources.statusforAddingTrackersSource = "failed";
            })
            .addCase(getJsSourcesRedux.pending, (state) => {
                state.getAllSources.statusSourceJs = "loading";
            })
            .addCase(getJsSourcesRedux.fulfilled, (state, action) => {
                state.getAllSources.statusSourceJs = "success";
                state.getAllSources.sourceJs =
                    action.payload.data && action.payload.data;
            })
            .addCase(getJsSourcesRedux.rejected, (state, action) => {
                state.getAllSources.statusSourceJs = "failed";
            });
    },
});

export default sourcesSlice.reducer;
export const { updateSourceInList } = sourcesSlice.actions;
